"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubFiscaliteApplicableScpiCorporation = void 0;
exports.ESubFiscaliteApplicableScpiCorporation = {
    revenusFonciers: "revenusFonciers",
    dividendes: "dividendes",
    pasDeFiscalite: "pasDeFiscalite",
    neSaisPas: "neSaisPas",
};
